import { Navigate, Route, Routes } from 'react-router-dom';
import AppShell from './components/AppShell';
import ProtectedRoute from './components/ProtectedRoute';
import RequireRole from './components/RequireRole';
import DesignSystem from './pages/DesignSystem';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import AgentStudioDetail from './pages/agent-studio/AgentStudioDetail';
import AgentStudioEdit from './pages/agent-studio/AgentStudioEdit';
import AgentStudioExecutions from './pages/agent-studio/AgentStudioExecutions';
import AgentStudioList from './pages/agent-studio/AgentStudioList';
import AgentStudioVersions from './pages/agent-studio/AgentStudioVersions';
import GeologistWorkspace from './pages/agent-studio/GeologistWorkspace';

/** Landing route. Kept as a constant because several screens navigate here. */
const WORKSPACE_PATH = '/agents/geologist/workspace';

/**
 * Route table.
 *
 * Paths reproduce the host application exactly so that existing deep links,
 * bookmarks and the in-page `navigate()` calls inside the inherited
 * agent-studio screens keep resolving. In particular `versions` and
 * `executions` are nested under `/agents/:system_name/`, which is what
 * `useParams<{ system_name, version_id }>()` in those screens expects.
 */
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* Unauthenticated on purpose. The design system renders no archive data —
          only the fixed sample values from the design brief — and it has to be
          reviewable without an account, on a machine with no database. */}
      <Route path="/design" element={<DesignSystem />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<Navigate to={WORKSPACE_PATH} replace />} />

          <Route path="/agents" element={<AgentStudioList />} />
          <Route path={WORKSPACE_PATH} element={<GeologistWorkspace />} />

          <Route path="/agents/:system_name" element={<AgentStudioDetail />} />
          <Route path="/agents/:system_name/versions" element={<AgentStudioVersions />} />
          <Route
            path="/agents/:system_name/versions/:version_id"
            element={<AgentStudioVersions />}
          />
          <Route path="/agents/:system_name/executions" element={<AgentStudioExecutions />} />
          <Route
            path="/agents/:system_name/executions/:execution_id"
            element={<AgentStudioExecutions />}
          />
          <Route
            path="/agents/:system_name/edit"
            element={
              <RequireRole permission="agent.write">
                <AgentStudioEdit />
              </RequireRole>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  );
}
